export let UnsupportedImageSuffix = /*#__PURE__*/function (UnsupportedImageSuffix) {
  UnsupportedImageSuffix["SVG"] = ".svg";
  UnsupportedImageSuffix["GIF"] = ".gif";
  UnsupportedImageSuffix["AVIF"] = ".avif";
  UnsupportedImageSuffix["APNG"] = ".apng";
  return UnsupportedImageSuffix;
}({});
export const UNSUPPORTED_AI_IMAGE_EXTENSIONS = [UnsupportedImageSuffix.SVG, UnsupportedImageSuffix.GIF, UnsupportedImageSuffix.AVIF, UnsupportedImageSuffix.APNG];
export const getIsAiSupported = uri => !UNSUPPORTED_AI_IMAGE_EXTENSIONS.some(ext => uri.endsWith(ext));
//# sourceMappingURL=get-is-ai-supported.js.map